import React, { useState, useEffect, useCallback } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { FaGripVertical} from "react-icons/fa";
import axios from 'axios';
import authHeader from "../services/AuthHeader";
import { FaWindowClose } from 'react-icons/fa';
import {
  MdDelete,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
} from 'react-icons/md';
import { FormControl, Checkbox } from 'react-bootstrap';
import _ from 'lodash';
import AddCandidate from './AddCandidate';
import DragDropCandidates from './DragDropCandidates';
import confirmDialog from '../services/confirmDialog';

const DragDrop = (props) => {
  let stateVars = {};
  const [partyData, setPartyData] = useState([]);
  const [rerender, setRerender] = useState(false);
  const [ballotRestrictions, setBallotRestrictions] = useState([]);
  const [updateBallot, setUpdateBallot] = useState({});
  const [newCandidateList, setNewCandidateList] = useState([]);
  const [isLocked, setIsLocked] = useState(false);
     /* Get election data, use stateVars as dynamic var to maintain state for each ballot */
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_BASE + 'election/', {
        headers: authHeader(),
      })
      .then((res) => {
        props.setBallotData(res.data);
        setIsLocked(res.data.locked);
        res.data.allBallots.map((ballot) => {
          stateVars['ib_' + ballot.ballotId] = ballot;
          return 1;
        });
        setRerender(false);
      });
  }, [rerender]);

  /* Get all parties for drop down selection */
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_BASE + 'party/', { headers: authHeader() })
      .then((res) => {
        setPartyData(res.data);
      });
  }, []);
  
  /* get ballot restrictions for drop down selection */
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_BASE + 'ballotrestrictions/', {
        headers: authHeader(),
      })
      .then((res) => {
        setBallotRestrictions(res.data);
      });
  }, []);

  const [state, setState] = useState(stateVars);

  const onChange = (name) => {
    setRerender(true);
    setState((prevState) => ({
      ...prevState,
      ['bg_' + name]: state['bg_' + name] ? false : true,
    }));
  };

  /* Delete ballot on confirmation */
  const onDelete = async (ballotId) => {
    const result = await confirmDialog('Delete this ballot?', {
      confirmLabel: 'Delete',
      confirmStyle: 'danger',
      title: 'Delete Ballot',
    });
    if (result) {
      let ballotIndex;
      //let result;
      let tempBallotData = props.ballotData.allBallots;
      axios
        .delete(process.env.REACT_APP_API_BASE + 'ballot/' + ballotId, {
          headers: authHeader(),
        })
        .then(
          ballotIndex =  props.ballotData.allBallots.findIndex(
            (x) => parseInt(x.ballotId) === parseInt(ballotId)
          ),
          reorderDelete(tempBallotData, ballotIndex),
          setRerender(true) 
        );
    }
  };

  /* update order after deletion of ballot */
  const reorderDelete = (tempData, ballotIndex) => {
    for (var j = ballotIndex; j < tempData.length; j++){
      tempData[j].sortOrder = j;
    }
     axios
      .put(process.env.REACT_APP_API_BASE + 'reorderballots/1', tempData, {
        headers: authHeader(),
      }) 
    return tempData;
  };

  /* Update individual ballot information */
  const onChangeHandle = (evt, name, ballotId) => {
    debounce(evt, name, ballotId);
  };

  /* Use debounce to wait for user to finish typing */
  const debounce = useCallback(
    _.debounce((evt, name, ballotId) => {
      let newValue = '';
      if (name === 'numberChosen') {
        newValue = parseInt(evt.target.value);
      } else if (name === 'writeIn' || name === 'referendum') {
        newValue = evt.target.checked ? true : false;
      } else {
        newValue = evt.target.value;
      }
      const updBallot = {
        [name]: newValue,
      };

      if(name === 'referendum') {
        axios
        .put(process.env.REACT_APP_API_BASE + 'ballot/' + ballotId, updBallot, {
          headers: authHeader(),
        })
        .then(
          setRerender(true)
        )
      } else {
        axios
        .put(process.env.REACT_APP_API_BASE + 'ballot/' + ballotId, updBallot, {
          headers: authHeader(),
        })
      }
    }, 1000),
    []
  );

  /* Update individual ballot restrictions */
  const onChangeHandleRestrictions = (
    evt,
    name,
    ballotId,
    ballotRestrictionId
  ) => {
    debounceRestrictions(evt, name, ballotId, ballotRestrictionId);
  };

  const debounceRestrictions = useCallback(
    _.debounce((evt, name, ballotId, ballotRestrictionId) => {
      let newValue = evt.target.value;
      let ballotRestrictionTypeId = '';
      if (evt.target.value === null || evt.target.value === '0') {
        ballotRestrictionTypeId = 1;
      } else if (evt.target.value === 'G') {
        ballotRestrictionTypeId = 2;
      } else if (evt.target.value === 'O' || evt.target.value === 'R') {
        ballotRestrictionTypeId = 4;
      } else {
        ballotRestrictionTypeId = 3;
      }

      const updBallot = {
        [name]: newValue,
        BallotId: ballotId,
        BallotRestrictionTypeId: ballotRestrictionTypeId,
      };

      axios
        .put(
          process.env.REACT_APP_API_BASE +
            'ballotRestrictions/' +
            ballotRestrictionId,
          updBallot,
          {
            headers: authHeader(),
          }
        )
    }, 1000),
    []
  );

  /* Update ballot */
  const handleUpdateBallot = (ballotId) => {
    var foundIndex = props.ballotData.allBallots.findIndex(
      (x) => parseInt(x.ballotId) === parseInt(ballotId)
    );

    setUpdateBallot({
      ...props.ballotData.allBallots[foundIndex],
    });
  };

  /* Update ballot to referendum with pre-set options */
  const handleReferendum = (evt, ballotId) => {
    const referendumCandidates = [
      {
        ballotId: ballotId,
        ballotCandidateName: 'Yes',
        ballotCandidatePartyId: null,
      },
      {
        ballotId: ballotId,
        ballotCandidateName: 'No',
        ballotCandidatePartyId: null,
      },
      {
        ballotId: ballotId,
        ballotCandidateName: 'Abstain',
        ballotCandidatePartyId: null,
      },
    ];

    axios
      .delete(process.env.REACT_APP_API_BASE + 'referendum/' + ballotId, {
        headers: authHeader(),
      })
      .then((res) => {
        if (evt.target.checked) {
          axios
            .post(
              process.env.REACT_APP_API_BASE + 'referendum/',
              referendumCandidates,
              {
                headers: authHeader(),
              }
            )
        }
      });
      onChangeHandle(evt, 'referendum', ballotId);    
  };

  /* set focus */
  const handleFocus = (event) => event.target.select();


  if (isLocked) {
    return (
      <div className='App'>
        <b>Election is Active and Cannot Be Edited</b>
      </div>
    );
  }
  const initial = props.ballotData.allBallots.map((k) => ({
    ballotId: `${k.ballotId}`,
    ballotName: k.ballotName,
    ballotDetail: k.ballotDetail,
    ballotRestrictionId: k.ballotRestrictionId,
    ballotRestrictionDetail: k.ballotRestrictionDetail,
    ballotRestrictionTypeId: k.ballotRestrictionTypeId,
    numberChosen: k.numberChosen,
    writeIn: k.writeIn,
    sortOrder: k.sortOrder,
    referendum: k.referendum,
    allCandidates: k.allCandidates,
  }));

  /* Update ballot order */
  const reorder = (list, startIndex, endIndex) => {
    if (
      startIndex === endIndex
      || endIndex < 0
      || endIndex >= list.length
    ) {
      return list;
    }

    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    const normalizedBallots = result.map((ballot, index) => ({
      ...ballot,
      sortOrder: index + 1,
    }));

    props.setBallotData((prevBallotData) => ({
      ...prevBallotData,
      allBallots: normalizedBallots,
    }));

    const output = normalizedBallots.map(({ ballotId, ...rest }) => ({
      ...rest,
      ballotId: +ballotId,
    }));

    axios
      .put(process.env.REACT_APP_API_BASE + 'reorderballots/1', output, {
        headers: authHeader(),
      });

    return normalizedBallots;
  };

  const moveBallot = (list, index, direction) =>
    reorder(list, index, index + direction);
      
      /* Set ballots as draggable */
      function Ballot({ ballot, index, ballotCount, onMoveBallot }) {
        const isFirstBallot = index === 0;
        const isLastBallot = index === ballotCount - 1;

        return (
          <Draggable draggableId={ballot.ballotId} index={index} key={index}>
            {(provided) => (
              <div
                className='bg-wrapper'
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
              >
                <div
                  id={'bg_' + ballot.ballotId}
                  className='bg-left'
                  role={!state['bg_' + ballot.ballotId] ? 'button' : undefined}
                  tabIndex={!state['bg_' + ballot.ballotId] ? 0 : undefined}
                  aria-label={
                    !state['bg_' + ballot.ballotId]
                      ? `Edit ballot ${ballot.ballotName}`
                      : undefined
                  }
                  onDoubleClick={() => onChange(ballot.ballotId)}
                  onKeyDown={
                    !state['bg_' + ballot.ballotId]
                      ? (evt) => {
                          if (evt.key === 'Enter' || evt.key === ' ') {
                            evt.preventDefault();
                            onChange(ballot.ballotId);
                          }
                        }
                      : undefined
                  }
                >
                  {!state['bg_' + ballot.ballotId] ? (
                  <>
                  <div>
                    <FaGripVertical title='drag to reorder ballot' /> {ballot.ballotName}
                  </div>
                  <div className='indent-candidate'>
                    {ballot.allCandidates.map((candidate) => {
                      return (
                        <div>
                          {candidate.ballotCandidateName}-{' '}
                          {candidate.ballotCandidatePartyName
                            ? candidate.ballotCandidatePartyName
                            : 'Independent'}
                        </div>
                      );
                    })}
                  </div>
                  </>
                  ) : (
                    <>
                          <table width='100%'>
                           <tbody>
                            <tr>
                              <td><FaGripVertical title='drag to reorder ballot' /> Edit Ballot:</td>
                            </tr>
                            <tr>
                              <td>
                                <FormControl
                                  defaultValue={ballot.ballotName}
                                  key={'bn_' + ballot.ballotId}
                                  name={'bn_' + ballot.ballotId}
                                  aria-label={`Ballot name for ${ballot.ballotName}`}
                                  style={{ width: '90%' }}
                                  onChange={(evt) =>
                                    onChangeHandle(
                                      evt,
                                      'ballotName',
                                      ballot.ballotId
                                    )
                                  }
                                  onFocus={handleFocus}
                                />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <table width='100%'>
                                <tbody>
                                  <tr>
                                    <td width='16%'> Referendum:</td>
                                    <td
                                      style={{
                                        verticalAlign: 'middle',
                                        paddingTop: '25px',
                                      }}
                                    >
                                      <Checkbox
                                        aria-label={`Referendum ballot toggle for ${ballot.ballotName}`}
                                        onChange={(evt) =>
                                          handleReferendum(evt, ballot.ballotId)
                                        }
                                        defaultChecked={ballot.referendum}
                                      />
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td>Manage Candidates:</td>
                            </tr>
                            <tr>
                              <td>
                                <div className='indent-candidate'>
                                  <DragDropCandidates
                                    allCandidates={ballot.allCandidates}
                                    referendum={ballot.referendum}
                                    ballotId={ballot.ballotId}
                                    outerIndex={index}
                                    partyData={partyData}
                                    ballotData={props.ballotData}
                                    setBallotData={props.setBallotData}
                                    updateBallot={updateBallot}
                                    handleUpdateBallot={handleUpdateBallot}
                                    setRerender={setRerender}
                                  />
                                  {!ballot.referendum ? (
                                    <AddCandidate
                                      newCandidateList={newCandidateList}
                                      ballotId={ballot.ballotId}
                                      setNewCandidateList={setNewCandidateList}
                                      partyData={partyData}
                                      setRerender={setRerender}
                                    />
                                  ) : (
                                    ''
                                  )}
                                </div>
                              </td>
                            </tr>
                            {!ballot.referendum ? (
                              <>
                              <tr>
                                <td>
                                  <table width='100%'>
                                  <tbody>
                                    <tr>
                                      <td width='18%'> Allow Write Ins:</td>
                                      <td
                                        style={{
                                          verticalAlign: 'middle',
                                          paddingTop: '25px',
                                        }}
                                      >
                                        <Checkbox
                                          aria-label={`Allow write-in candidates for ${ballot.ballotName}`}
                                          onChange={(evt) =>
                                            onChangeHandle(
                                              evt,
                                              'writeIn',
                                              ballot.ballotId
                                            )
                                          }
                                          defaultChecked={ballot.writeIn}
                                        />
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                              <td>
                                <table width='100%'>
                                <tbody>
                                  <tr>
                                    <td width='30%'>
                                      {' '}
                                      Number of Selections Allowed:
                                    </td>
                                    <td style={{ height: '20px', rows: '5' }}>
                                      <FormControl
                                        type='text'
                                        defaultValue={ballot.numberChosen}
                                        aria-label={`Number of selections allowed for ${ballot.ballotName}`}
                                        style={{ width: '10%', height: '30px' }}
                                        onChange={(evt) =>
                                          onChangeHandle(
                                            evt,
                                            'numberChosen',
                                            ballot.ballotId
                                          )
                                        }
                                      />
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            </>
                            ) : (
                              <tr>
                                <td>
                                  <table width='100%'>
                                  <tbody>
                                    <tr>
                                      <td
                                        width='30%'
                                        style={{
                                          verticalAlign: 'top',
                                          paddingTop: '25px',
                                        }}
                                      >
                                        {' '}
                                        Ballot Details:
                                      </td>
                                      <td
                                        style={{
                                          verticalAlign: 'middle',
                                          paddingTop: '25px',
                                        }}
                                      >
                                        <FormControl
                                          componentClass='textarea'
                                          defaultValue={ballot.ballotDetail}
                                          aria-label={`Ballot details for ${ballot.ballotName}`}
                                          className='textarea-ballot-detail'
                                          style={{ width: '80%',marginBottom: '5px' }}
                                          onChange={(evt) =>
                                            onChangeHandle(
                                              evt,
                                              'ballotDetail',
                                              ballot.ballotId
                                            )
                                          }
                                        />
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            )}
                            <tr>
                              <td>
                                <table width='100%'>
                                <tbody>
                                  <tr>
                                    <td width='30%'> Restrictions:</td>
                                    <td style={{ height: '20px' }}>
                                      <FormControl
                                        componentClass='select'
                                        placeholder='select'
                                        aria-label={`Restrictions for ${ballot.ballotName}`}
                                        style={{ width: '70%' }}
                                        onChange={(evt) =>
                                          onChangeHandleRestrictions(
                                            evt,
                                            'ballotRestrictionDetail',
                                            ballot.ballotId,
                                            ballot.ballotRestrictionId
                                          )
                                        }
                                      >
                                        <option value=''>
                                          Select Restriction
                                        </option>
                                        <option
                                          value='0'
                                          selected={
                                            ballot.ballotRestrictionDetail ===
                                              '' ||
                                            ballot.ballotRestrictionDetail ===
                                              '0'
                                          }
                                        >
                                          None
                                        </option>
                                        {ballotRestrictions.map((x) => (
                                          <option
                                            selected={
                                              ballot.ballotRestrictionDetail ===
                                              x.ballotRestrictionDetail
                                            }
                                            key={x.ballotRestrictionDetailId}
                                            value={x.ballotRestrictionDetail}
                                          >
                                            {x.ballotRestrictionDescription}
                                          </option>
                                        ))}
                                      </FormControl>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </>
                  )}
                </div>
                <div className='bg-right ballot-actions-column'>
                      <div
                        className='ballot-order-controls'
                        role='group'
                        aria-label={`Move ballot ${ballot.ballotName}`}
                      >
                        <button
                          type='button'
                          className='ballot-order-button'
                          aria-label={`Move ballot ${ballot.ballotName} up`}
                          onClick={() => onMoveBallot(index, -1)}
                          disabled={isFirstBallot}
                        >
                          <MdKeyboardArrowUp size={20} aria-hidden='true' />
                        </button>
                        <button
                          type='button'
                          className='ballot-order-button'
                          aria-label={`Move ballot ${ballot.ballotName} down`}
                          onClick={() => onMoveBallot(index, 1)}
                          disabled={isLastBallot}
                        >
                          <MdKeyboardArrowDown size={20} aria-hidden='true' />
                        </button>
                      </div>
                      {!state['bg_' + ballot.ballotId] ? (
                        <button
                          type='button'
                          className='icon-button'
                          aria-label={`Delete ballot ${ballot.ballotName}`}
                          onClick={() => onDelete(ballot.ballotId)}
                        >
                          <MdDelete
                            className='delete-icon'
                            size={30}
                            title='remove ballot'
                            aria-hidden='true'
                          />
                        </button>
                      ) : (
                        <button
                          type='button'
                          className='icon-button'
                          aria-label={`Close editor for ${ballot.ballotName}`}
                          onClick={() => onChange(ballot.ballotId)}
                        >
                          <FaWindowClose size={30} title='close' aria-hidden='true'/>
                        </button>
                      )}
                    </div>
              </div>
            )}
          </Draggable>
        );
      }

      /* List of all ballots in election */
      const BallotList = React.memo(function BallotList({ ballots, onMoveBallot }) {
        return ballots.map((ballot, index) => (
          <Ballot
            ballot={ballot}
            index={index}
            ballotCount={ballots.length}
            key={ballot.ballotId}
            onMoveBallot={onMoveBallot}
          />
        ));
      });
      
      function BallotApp() {
        const [state, setState] = useState({ ballots: initial });

        function onDragEnd(result) {
          if (!result.destination) {
            return;
          }

          if (result.destination.index === result.source.index) {
            return;
          }

          const ballots = reorder(
            state.ballots,
            result.source.index,
            result.destination.index
          );

          setState({ ballots });
        }

        const handleMoveBallot = (index, direction) => {
          const ballots = moveBallot(state.ballots, index, direction);
          setState({ ballots });
        };

        return (
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId='list'>
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  <BallotList
                    ballots={state.ballots}
                    onMoveBallot={handleMoveBallot}
                  />
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        );
      }

    return (<BallotApp />)
}

export default DragDrop;
